// Helpers for GameResult rows from the game platform.
//
// `result` is free-form per game: the Maze stores a short status ("won" /
// "lost"), while older games (e.g. the bicycle game) store JSON payloads with
// track data, speed, etc. Only a short single status word is treated as a
// status; JSON and longer data are ignored everywhere in the app.

const RESULT_STATUS_PATTERN = /^[A-Za-z][A-Za-z0-9 _-]{0,19}$/;

/** The result's short status (e.g. "won"), or null when it has none. */
export const getResultStatus = (result) => {
  const value = typeof result?.result === 'string' ? result.result.trim() : '';
  return RESULT_STATUS_PATTERN.test(value) ? value : null;
};

/** True only for a result explicitly saved as "lost". */
export const isLostResult = (result) => getResultStatus(result)?.toLowerCase() === 'lost';

/**
 * A finish time that can count as a best time: positive, and not a lost run
 * (a lost Maze run's time is just the time limit).
 */
export const isBestTimeCandidate = (result) => {
  const time = Number(result?.finishTime);
  return Number.isFinite(time) && time > 0 && !isLostResult(result);
};

const STATUS_STYLES = {
  won: 'bg-emerald-100 text-emerald-700',
  win: 'bg-emerald-100 text-emerald-700',
  lost: 'bg-rose-100 text-rose-700',
  loss: 'bg-rose-100 text-rose-700',
};

/** Tailwind classes for a status badge; neutral for statuses we don't know. */
export const getResultStatusClassName = (status) =>
  STATUS_STYLES[String(status || '').toLowerCase()] || 'bg-gray-100 text-gray-700';

/** Display name for a user object from the API. */
export const getUserDisplayName = (user) => user?.full_name || user?.user_name || 'Player';
